import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { apiClient } from "../../services/api";

/**
 * Forgot Password — always shows the same success message whether the email
 * exists or not, per spec. 60-second countdown before Resend is enabled.
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown <= 0) return undefined;
    const id = setInterval(() => setCooldown((c) => Math.max(0, c - 1)), 1000);
    return () => clearInterval(id);
  }, [cooldown]);

  const submit = async () => {
    if (!email.trim()) return toast.error("Please enter your email");
    setBusy(true);
    try {
      await apiClient.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
      setCooldown(60);
    } catch {
      // Server never leaks — but network errors can still happen.
      toast.error("Could not send request. Try again in a minute.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4" style={{ background: "var(--canvas, #F4F3F1)" }}>
      <div className="w-full max-w-md bg-white rounded-[20px] p-6" data-testid="forgot-password-page">
        <h1 style={{ fontFamily: "Barlow Condensed, sans-serif", fontWeight: 700, fontSize: 28 }}>Forgot password</h1>
        <p style={{ fontFamily: "Barlow, sans-serif", fontSize: 14, color: "#4A4845", marginTop: 6 }}>
          Enter your email and we'll send you a link to reset your password.
        </p>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          data-testid="forgot-email"
          className="w-full mt-4 h-12 px-3 rounded-[12px] border border-line bg-canvas2 outline-none"
        />
        <button
          onClick={submit}
          disabled={busy || cooldown > 0}
          data-testid="forgot-submit"
          className="w-full mt-3 h-12 rounded-pill disabled:opacity-50"
          style={{ background: "#0C0C0B", color: "#F4F3F1", borderRadius: 100, fontWeight: 700 }}
        >
          {busy ? "Sending…" : (cooldown > 0 ? `Resend in ${cooldown}s` : (sent ? "Resend link" : "Send reset link"))}
        </button>
        {sent && (
          <p data-testid="forgot-sent-msg" style={{ marginTop: 12, fontSize: 12, color: "#15803D", textAlign: "center" }}>
            If that email is registered, a reset link has been sent.
          </p>
        )}
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <Link to="/login" style={{ fontSize: 12, color: "#4A4845" }}>Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
